export default "__VITE_ASSET__Diaq4xMQ__"